import { createContext } from 'react';
import { QUERY_KEYS_VEHICLES, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const VehiclesChartsDataContext = createContext();

const VehiclesChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_BRAND,
            url: 'governanceroom/securitydashboard/vehicles/brand'
        },
        filterParams
    );

    const typeEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_TYPE,
            url: 'governanceroom/securitydashboard/vehicles/type'
        },
        filterParams
    );

    const yearEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_YEAR,
            url: 'governanceroom/securitydashboard/vehicles/year'
        },
        filterParams
    );

    const colorEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_VEHICLES.VEHICLES_COLOR,
            url: 'governanceroom/securitydashboard/vehicles/color'
        },
        filterParams
    );

    const chartData = {
            brandAnual: data?.anualEvolution || [],
            brandMonth: data?.monthEvolution || [],
            typeAnual: typeEvolutionData.data?.anualEvolution || [],
            typeMonth: typeEvolutionData.data?.monthEvolution || [],
            yearAnual: yearEvolutionData.data?.anualEvolution || [],
            yearMonth: yearEvolutionData.data?.monthEvolution || [],
            colorAnual: colorEvolutionData.data?.anualEvolution || [],
            colorMonth: colorEvolutionData.data?.monthEvolution || [],
          }

    return (
        <VehiclesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </VehiclesChartsDataContext.Provider>
    );
};

export default VehiclesChartsDataProvider;
